var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/*
 * This file is part of the nivo project.
 *
 * Copyright 2016-present, Raphaël Benitte.
 *
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */
import { useMemo } from 'react';
import get from 'lodash/get';
import { arc as d3Arc, pie as d3Pie } from 'd3-shape';
import { degreesToRadians, radiansToDegrees } from '@nivo/core';

export var usePie = function usePie(_ref) {
    var data = _ref.data,
        radius = _ref.radius,
        _ref$value = _ref.value,
        value = _ref$value === undefined ? function (v) {
        return v;
    } : _ref$value,
        _ref$startAngle = _ref.startAngle,
        startAngle = _ref$startAngle === undefined ? 0 : _ref$startAngle,
        _ref$endAngle = _ref.endAngle,
        endAngle = _ref$endAngle === undefined ? 360 : _ref$endAngle,
        _ref$innerRadius = _ref.innerRadius,
        innerRadius = _ref$innerRadius === undefined ? 0 : _ref$innerRadius,
        _ref$cornerRadius = _ref.cornerRadius,
        cornerRadius = _ref$cornerRadius === undefined ? 0 : _ref$cornerRadius,
        _ref$sortByValue = _ref.sortByValue,
        sortByValue = _ref$sortByValue === undefined ? false : _ref$sortByValue,
        _ref$padAngle = _ref.padAngle,
        padAngle = _ref$padAngle === undefined ? 0 : _ref$padAngle;

    var arcGenerator = useMemo(function () {
        return d3Arc().outerRadius(radius).innerRadius(innerRadius).cornerRadius(cornerRadius);
    }, [radius, innerRadius, cornerRadius]);

    var getValue = useMemo(function () {
        return typeof value === 'function' ? value : function (d) {
            return get(d, value);
        };
    }, [value]);

    var pie = useMemo(function () {
        var computedPie = d3Pie().value(getValue).padAngle(degreesToRadians(padAngle)).startAngle(degreesToRadians(startAngle)).endAngle(degreesToRadians(endAngle));

        if (sortByValue !== true) computedPie.sortValues(null);

        return computedPie;
    }, [getValue, padAngle, startAngle, endAngle, sortByValue]);

    var arcs = useMemo(function () {
        return pie(data).map(function (arc) {
            var angle = arc.endAngle - (arc.endAngle - arc.startAngle) * 0.5;

            return _extends({}, arc, {
                startAngleDeg: radiansToDegrees(angle.startAngle),
                endAngleDeg: radiansToDegrees(arc.endAngle),
                angle: angle,
                angleDeg: radiansToDegrees(angle)
            });
        });
    }, [data, pie]);

    return { arcs: arcs, arcGenerator: arcGenerator };
};